var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.8333C2.5 8.99238 3.99238 7.5 5.83333 7.5H14.1667C16.0076 7.5 17.5 8.99238 17.5 10.8333V14.1151C17.5 15.7971 15.8724 16.9992 14.2648 16.5045L12.7258 16.031C12.3049 15.9015 11.8574 15.8855 11.4284 15.9845L7.42996 16.9072C6.93301 17.0219 6.41287 16.9818 5.93934 16.7924L4.07152 16.0453C3.12238 15.6656 2.5 14.7463 2.5 13.7241V10.8333Z",
    fill: "#F4F4F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 6.66667C14.1666 10 9.99998 12.0833 9.99998 12.0833C9.99998 12.0833 5.83331 10 5.83331 6.66667C5.83331 4.36548 7.69879 2.5 9.99998 2.5C12.3012 2.5 14.1666 4.36548 14.1666 6.66667Z",
    fill: "#E73838",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8129 8.33331C14.0325 7.82109 14.1663 7.26393 14.1663 6.66665C16.4675 6.66665 18.333 8.53213 18.333 10.8333V14.1151C18.333 16.3578 16.1629 17.9606 14.0194 17.301L12.4803 16.8275C12.1998 16.7411 11.9014 16.7304 11.6154 16.7964L7.617 17.7192C6.9544 17.8721 6.26088 17.8187 5.6295 17.5661L3.76168 16.819C2.49616 16.3128 1.66632 15.0871 1.66632 13.7241V10.8333C1.66632 8.53212 3.5318 6.66665 5.83299 6.66665C5.83299 7.26393 5.96677 7.82109 6.18639 8.33331H5.83299C4.45228 8.33331 3.33299 9.4526 3.33299 10.8333V13.7241C3.33299 14.4056 3.74791 15.0184 4.38067 15.2715L6.24848 16.0186C6.56417 16.1449 6.91093 16.1716 7.24224 16.0952L11.2407 15.1725C11.8127 15.0405 12.4094 15.0619 12.9705 15.2345L14.5095 15.708C15.5813 16.0378 16.6663 15.2364 16.6663 14.1151V10.8333C16.6663 9.4526 15.547 8.33331 14.1663 8.33331H13.8129Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.66667C11.25 7.35702 10.6904 7.91667 10 7.91667C9.30964 7.91667 8.75 7.35702 8.75 6.66667C8.75 5.97631 9.30964 5.41667 10 5.41667C10.6904 5.41667 11.25 5.97631 11.25 6.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.a3e44cab2980c749a00939e22edbc433.svg";
export { ForwardRef as ReactComponent };